import "./farmers.scss"

import { h, render } from "preact"
import { FarmersAndPlaces } from "./js/components/farmers-and-places"

import { qs } from "./js/util/dom"

$(() => {
  const fnp = qs("#farmers-and-places")
  if (fnp) {
    fnp.innerHTML = ""
    render(<FarmersAndPlaces root={fnp} />, fnp)
  }
})
